// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2-fz7","inputDescription":"styles_inputDescription__33W7f"};